import axios from "axios";
import { deltamathAPI } from "../../utils";

/**
 * Downloads the Mail List Excel file from the server.
 */
export const downloadMailList = async (): Promise<void> => {
  try {
    const response = await axios.request({
      method: "get",
      url: deltamathAPI() + "/manager_new/renewals/mail-lists",
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });

    const file = response.data;
    const href = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "MailListReport.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading the mail list:", error);
    alert("Failed to download the mail list. Please try again.");
  }
};
